import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../_images/coupon-unit.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-15125bdb")

_pushScopeId("data-v-15125bdb")
const _hoisted_1 = { class: "coupon-left" }
const _hoisted_2 = { class: "coupon-price" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "coupon-unit",
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "coupon-right" }
const _hoisted_5 = { class: "coupon-title" }
const _hoisted_6 = {
  key: 0,
  class: "coupon-button cancel-button"
}
const _hoisted_7 = {
  key: 1,
  class: "coupon-button confirm-button"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["commonPayV2_couponList coupon-list", { 'flex-space-around': _ctx.payPackages.length <= 2 }]
  }, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.couponList, (coupon, index) => {
      return (_openBlock(), _createBlock("div", {
        key: coupon.coupon_product_id,
        class: ["coupon-item", { active: _ctx.viewModel.isUseCoupon && _ctx.activatedIndex === index }],
        onClick: ($event: any) => (_ctx.clickCoupon(index))
      }, [
        _createVNode("div", _hoisted_1, [
          _createVNode("span", _hoisted_2, [
            _createTextVNode(_toDisplayString(coupon.page_detail.discount) + " ", 1),
            _hoisted_3
          ])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("span", _hoisted_5, _toDisplayString(coupon.page_detail.name), 1),
          (_ctx.viewModel.isUseCoupon && _ctx.activatedIndex === index)
            ? (_openBlock(), _createBlock("button", _hoisted_6, " 取消 "))
            : (_openBlock(), _createBlock("button", _hoisted_7, "使用"))
        ]),
        (_ctx.$slots.couponPosition)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: 'slotCouponPosition' + index
            }, [
              _renderSlot(_ctx.$slots, "couponPosition", {}, undefined, true)
            ], 2))
          : _createCommentVNode("", true)
      ], 10, ["onClick"]))
    }), 128))
  ], 2))
})